export enum ActionTypes {
  EDIT = 'edit',
  DELETE = 'delete',
  TRANSFER = 'transfer',
}
